<template>
  <Modal
    :show="show"
    :action-text="actionText"
    :cancel-text="cancelText"
    :disabled="!valid"
    @action="submitForm()"
    @close="close()"
  >
    <template #title>
      <slot name="title" />
    </template>

    <template #content>
      <slot name="info" />
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submitForm"
      >
        <DpplTextField
          v-model="name"
          :label="label"
          outlined
          :rules="nameRules"
          dense
          @change="trimName"
        />
      </v-form>
    </template>
  </Modal>
</template>

<script>
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import Modal from '@/components/shared/Modal.vue';
import validation from '@/helpers/validation';

export default {
  name: 'CreateModal',
  components: { DpplTextField, Modal },
  props: {
    show: { type: Boolean, default: false },
    actionText: { type: String, default: 'Create' },
    cancelText: { type: String, default: '' },
    label: { type: String, default: 'Name' },
  },
  emits: ['create', 'close'],

  data() {
    return {
      name: '',
      valid: false,
      nameRules: [
        (v) => !validation.isEmpty(v) || 'Name is required',
        (v) => (v && v.length <= 250) || 'Name is too long',
      ],
    };
  },

  methods: {
    async submitForm() {
      const formValidateResult = await this.$refs.form.validate();
      if (!formValidateResult.valid) {
        return;
      }

      this.$emit('create', {
        title: this.name,
        isPrivate: false,
        isTemplate: true,
      });
    },
    close() {
      this.name = '';
      this.$refs.form.resetValidation();
      this.$emit('close');
    },
    trimName() {
      this.name = validation.trimSpaces(this.name);
    },
  },
};
</script>
